export default "__VITE_ASSET__CLTafYgJ__"